import { FC } from 'react'
import { useT } from '_metronic/i18n/Metronici18n'
import { ListLoading, TableErrorState, TablePagination } from 'app/components'
import { SncrBloco } from '../core/_models'
import { QueryRequestProvider, useQueryRequest } from '../numeros/core/QueryRequestProvider'
import { QueryResponseProvider, useQueryResponse } from '../numeros/core/QueryResponseProvider'
import { SncrNumerosTabela } from './SncrNumerosTabela'

type IProps = {
  bloco: SncrBloco
}

const SncrNumerosUsadosLista: FC<IProps> = ({ bloco }) => {
  const { t } = useT()
  const { response, isLoading, isError, refetch } = useQueryResponse()
  const numeros = response?.data ?? []

  return (
    <div className='d-flex flex-column gap-4'>
      <p className='text-gray-700 mb-0'>
        {t('sncr.numeros.intro', {
          inicio: bloco.numeroInicio,
          fim: bloco.numeroFim,
          usados: bloco.quantidade - bloco.saldo,
        })}
      </p>

      {/* Erro antes do vazio: falha na busca não pode virar "nenhum número usado". */}
      {isError ? (
        <TableErrorState onRetry={refetch} />
      ) : isLoading && !response ? (
        <ListLoading />
      ) : numeros.length === 0 ? (
        <p className='text-gray-700 mb-0'>{t('sncr.numeros.vazio')}</p>
      ) : (
        <SncrNumerosTabela numeros={numeros} />
      )}

      {!isError && (
        <TablePagination
          useQueryRequest={useQueryRequest}
          useQueryResponse={useQueryResponse}
          itemLabel={{
            singular: t('sncr.numeros.item_singular'),
            plural: t('sncr.numeros.item_plural'),
          }}
        />
      )}
    </div>
  )
}

/** Em quais prescrições os números deste bloco foram usados, do mais recente para o mais antigo. */
export const SncrNumerosUsadosModal: FC<IProps> = ({ bloco }) => (
  <QueryRequestProvider>
    <QueryResponseProvider idBloco={bloco.id}>
      <SncrNumerosUsadosLista bloco={bloco} />
    </QueryResponseProvider>
  </QueryRequestProvider>
)
